export enum EToken {
    TOKEN="token",
}